import { featureEnabled } from 'utils';

export const getMlsUrlsAndNames = (mlsTypes?: string) => {
  const {
    location: { host },
  } = window;
  const isDev =
    process.env.NODE_ENV === 'development' ||
    host.startsWith('qa') ||
    host.startsWith('staging') ||
    host.startsWith('env4') ||
    host.includes('localhost');
  let name;
  let url;
  switch (mlsTypes) {
    case 'RECO':
      name = 'REcolorado';
      url = isDev
        ? 'https://recolorado-staging.clareity.net'
        : 'https://iam.recolorado.com';
      break;
    case 'TREB':
    case 'TRREB':
      name = 'PropTx';
      url = 'https://torontomls.net/';
      break;
    case 'MIBOR':
      name = 'MIBOR';
      url = 'https://iam.miborsecurity.com/idp/login';
      break;
    case 'SMLS':
      name = 'SmartMLS';
      url = isDev
        ? 'https://smartmls.matrixstaging.com'
        : 'https://smartmls.clareityiam.net/';
      break;
    case 'NCRMLS':
      name = 'NCRMLS';
      url = 'https://flexmls.com/';
      break;
    case 'ITSO':
      name = 'ITSO';
      url = 'https://iam.itsorealestate.ca/';
      break;
    default:
      return null;
  }

  return {
    name,
    url,
  };
};
